import { defineStore } from 'pinia';

export const useMenuStateStore = defineStore({
    id: 'menuStateStore',
    
    state() {
        return {
            covariatesValidated: false,
            measuresValidated: false,
            targetsValidated: false,
        };
    },
});
